module.exports = __webpack_public_path__ + "static/media/pause-button.2b01336e.svg";